export default __webpack_public_path__ + "870d28296fe4df95ef6adccf4c8e0685.svg";